<div 
  [style.direction]="(llefty) ? 'rtl' : 'ltr'"
  [ngStyle]="cssForFretboard">
  <div
    class="no-select"
    [ngStyle]="instruCss"
    (scroll)="onScroll($event)">
    <div [ngStyle]="fretboardCss">
      <div
        class="instrument-title"
        [ngStyle]="{
          origin: '14px',
          'font-size': (lmulti * 120) + '%'
        }">
        {{ title }}
      </div>
      <div *ngFor="let fretsOfThisString of frets; let stringIndex = index">
        <div *ngFor="let fret of fretsOfThisString; let fretNumber = index">
          <div 
            *ngIf="((stringIndex === 0) && ([3, 5, 7, 9, 12, 13].includes(fretNumber)))" 
            [ngStyle]="fret.cssDot"
            class="case dot">&nbsp;
          </div>
          <div
            *ngIf="lclickable"
            [ngStyle]="fret.cssClickable"
            class="case clickable"
            (touchstart)="noteClick(fret.note, stringIndex, fretNumber, true, true)"
            (touchend)="notePlayEnd(true)"
            (mousedown)="noteClick(fret.note, stringIndex, fretNumber, false, true)"
            (mouseup)="notePlayEnd(false)"
            (mouseleave)="notePlayEnd(false)"
            >
            &nbsp;
          </div>
          <div
            *ngIf="(lhighlightFrets.length > 0) && isHighlighted(stringIndex, fretNumber)"
            [ngStyle]="fret.cssHighlight"
            class="case highlight"
            [ngClass]="(fretNumber === 0) ? 'fret0' : ''">
            &nbsp;
          </div>

          <ng-container
            *ngIf="note12Display[fret.note12] || (stringIndex === lhighlightString)">
          
            <div *ngIf="isDisplay('intervals') && (intervalsDisplay[fret.note12] !== '')"
              [ngStyle]="getCSSNote(fret)"
              [ngClass]="classForNoteByString(stringIndex, fretNumber, fret.note12)"
              class="case fretboardnote"
              (touchstart)="noteClick(fret.note, stringIndex, fretNumber, true, true)"
              (touchend)="notePlayEnd(true)"
              (mousedown)="noteClick(fret.note, stringIndex, fretNumber, false, true)"
              (mouseup)="notePlayEnd(false)"
              (mouseleave)="notePlayEnd(false)"
              >
              <ng-container>
                {{ intervalsDisplay[fret.note12] }}
              </ng-container>
            </div>
            <div *ngIf="isDisplay('notes') || (intervalsDisplay[fret.note12] === '')"
              [ngStyle]="getCSSNote(fret)"
              [ngClass]="classForNoteByString(stringIndex, fretNumber, fret.note12)"
              class="case fretboardnote"
              (touchstart)="noteClick(fret.note, stringIndex, fretNumber, true, true)"
              (touchend)="notePlayEnd(true)"
              (mousedown)="noteClick(fret.note, stringIndex, fretNumber, false, true)"
              (mouseup)="notePlayEnd(false)"
              (mouseleave)="notePlayEnd(false)"
              >
              <ng-container *ngIf="isWithAStartNoteName || !isSharp(fret.note12)">
                {{ fret.display }}
              </ng-container>
              <div
                [style.font-size]="'.86em'"
                *ngIf="(!isWithAStartNoteName) && isSharp(fret.note12)">
                <span
                  [ngStyle]="{
                    'position': 'absolute',
                    'top': (-5 * lmulti) + 'px',
                    'left': '1px'
                  }">
                  {{ notesService.dispSharp(fret.note12, ldoremi) }}
                </span>
                <span
                  [ngStyle]="{
                    'position': 'absolute',
                    'bottom': (-6 * lmulti) + 'px',
                    'right': '1px'
                  }">
                  {{ notesService.dispFlat(fret.note12, ldoremi) }}
                </span>
              </div>
            </div>
            
          </ng-container>

        </div>
      </div>
      <div *ngIf="lwithTuners">
        <ng-container *ngFor="let detuneString of detuneStrings; let string = index">
          <string-tuning
            [multi]="lmulti"
            class="case"
            [ngStyle]="detuneString.tunerCss"
            [detune]="detuneString.value"
            (detuneChange)="changeDetune(string, $event)"
            (detuneReset)="resetStringTuning(string)"
            >
          </string-tuning>
        </ng-container>
        <div
          [ngStyle]="optionsStyle()" class="options">
          <div
            class="option"
            *ngIf="tunerOptionLabels[0] !== ''"
            [ngStyle]="optionStyle()"
            (click)="resetTunings()">
            {{ tunerOptionLabels[0] }}
          </div>
          <div
            class="option"
            *ngIf="tunerOptionLabels[1] !== ''"
            [ngStyle]="optionStyle()"
            (click)="selectTuning()">
            {{ tunerOptionLabels[1] }}
          </div>
          <div
            class="option"
            *ngIf="tunerOptionLabels[2] !== ''"
            [ngStyle]="optionStyle()"
            (click)="closeTuning()">
            {{ tunerOptionLabels[2] }}
          </div>
        </div>
      </div>
      <div *ngIf="lwithDetuneStrings">
        <ng-container *ngFor="let detuneString of detuneStrings">
          <div 
            class="case tuning" 
            [style.color]="detuneString.value <= 0 ? 'darkgreen' : 'red'"
            [ngStyle]="detuneString.css">
            {{ detuneString.display }}
          </div>
        </ng-container>
      </div>
      <div 
        class="case" 
        *ngFor="let fn of fretNumbers; let n = index" 
        [ngStyle]="fn.css">
        {{ n + 1 }}
      </div>
      <div *ngIf="!lwithTuners"
        class="optionLinks"
        [style.font-size]="(lmulti * .9) + 'em'"
        [style.text-align]="llefty ? 'right' : 'left'">
        <div *ngIf="(showIntervalsOption !== '') && (autoPlayNote12 !== -1) && (autoPlayType === 'chord')"
          class="optionLink"
          (click)="toggleDisplayNotesOrIntervals()">
          <ion-icon
            name="checkmark"
            [style.opacity]="(displayNotesOrIntervals === 'intervals') ? 1 : 0">
          </ion-icon>
          {{ showIntervalsOption }}
        </div>
        <div *ngIf="showAllNotesOption !== ''"
          class="optionLink"
          (click)="toggleAllNotes()">
          <ion-icon
            name="checkmark"
            [style.opacity]="showAllNotes ? 1 : 0">
          </ion-icon>
          {{ showAllNotesOption }}
        </div>
      </div>
    </div>
  </div>
</div>
